import { render, staticRenderFns } from "./StairLayout.vue?vue&type=template&id=f100b006&scoped=true&"
import script from "./StairLayout.vue?vue&type=script&lang=js&"
export * from "./StairLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f100b006",
  null
  
)

export default component.exports